import { render, staticRenderFns } from "./LfHonorStyleOne.vue?vue&type=template&id=31b3a806&"
import script from "./LfHonorStyleOne.vue?vue&type=script&lang=js&"
export * from "./LfHonorStyleOne.vue?vue&type=script&lang=js&"
import style0 from "./LfHonorStyleOne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports